import { rest } from 'msw';
import { getEnv } from 'util/getEnv';

export const chmlnSignatureMock = fn =>
  rest.get(`${getEnv('REACT_APP_ADMIN_API_URL')}/chmlnsignature`, fn);

export const handlers = () => [
  chmlnSignatureMock((_req, res, ctx) => {
    return res(
      ctx.json({
        uidHash: 'uidHash',
      }),
    );
  }),
];
